<template>
  <!--右侧购物车列表 -->
  <transition name="el-fade-in-linear">
    <div
      class="divliebiaor"
      v-show="dialogFormVisible"
    >

      <div class="divliebiaoright">
        <div class="listhead">
          <div class="listtitle">购物车</div>
          <div class="closed"><i
              class="el-icon-close"
              @click="closed"
            ></i></div>
        </div>
        <div class="listbody">
          <div
            class="listcheckall"
            style="padding-right: 12px;"
          >
            <el-checkbox
              v-model="checked"
              @change="call"
            ><span>全选</span></el-checkbox>
            <span
              @click="selectaddall(1,$event)"
              style="ont-size: 14px;color: #18bc9c;cursor: pointer;line-height: 2.0;"
            >
              清空
            </span>
          </div>
          <div
            class="gundong"
            style="height: 80%;"
          >
            <div
              class="bhover listcheckbody"
              style=" margin-left: 5px;margin-right: 5px;margin-bottom: 5px;padding-left: 15px;border-radius: 2px;box-shadow: 1px 1px 1px 1px #ccc;"
              v-for="(item,index) in dynamicTags"
              :key="item.product_id"
            >
              <!--  style="width:60%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"-->
              <div class="cartlisttitle">
                <el-checkbox
                  v-model="item.is_selected"
                  @change="zicheck(item.is_selected,index,item)"
                  style="width:60%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"
                >
                  {{item.product_name}}
                </el-checkbox>
                <i
                  class="el-icon-thirdinformation"
                  @click="selectinfo(item,$event)"
                ></i>
                <i
                  class="el-icon-delete"
                  @click="selectinfoadd(index,$event)"
                ></i>
                <i
                  class="el-icon-thirdearth"
                  @click="selectinfoshow(item,$event)"
                ></i>
              </div>
              <div class="cartlistbody"><span>{{item.product_date}}</span><span>面积：{{item.area}}km²</span><span style="color: red;">￥{{item.amountOfPay}}</span></div>
            </div>

          </div>
          <div style="font-size: 12px;
    color: red;
    padding-bottom: 10px;"><span>共计：{{totalCount}} 件商品</span><span> &nbsp; &nbsp; &nbsp;合计 ：{{totalAmount}} 元</span></div>
          <div class="zidingy">
            <el-button @click="cartConfirm">去购物车结算</el-button>
          </div>
        </div>
      </div>
    </div>

  </transition>

</template>

<script>
import Map from '../../common/map/Tmap.js'
import eventBus from '../../common/eventBus.js'
export default {
  name: 'HeadProductCartDialog',
  props: ['msgFather', 'prodata', 'checkAll'],
  data () {
    return {
      dialogFormVisible: false,
      dynamicTags: [],
      productdata: {},
      isshow: false,
      checked: false,
      gwc: [],
      jbo: [],
      isLogin: false,
      isFirst: false
    }
  },
  created () {
    this.dynamicTags = this.prodata
    this.dialogFormVisible = this.msgFather
    this.onLoginSuccess()
    this.onLogoutSuccess()
  },
  beforeUpdate() {
    if (!this.isFirst) {
      if (this.checkAll) {
        this.checked = true
      }
    }
    this.isFirst = true
  },
  computed: {
    totalCount() {
      // 查找出选中的数组
      let selectedList = this.dynamicTags.filter((item, index) => {
        return item.is_selected
      })
      return selectedList.length
    },
    totalAmount() {
      var total = 0
      // 查找出选中的数组
      let selectedList = this.dynamicTags.filter((item, index) => {
        return item.is_selected
      })
      selectedList.forEach(el => {
        total += el.amountOfPay * 1
      })
      return total.toFixed(2)
    }
  },
  methods: {
    // 监听登录成功购物车
    onLoginSuccess() {
      const that = this
      eventBus.$on('loginSuccess', cartInfo => {
        if (cartInfo.cartItems.length > 0) {
          that.dynamicTags = []
          cartInfo.cartItems.forEach(cartInfo => {
            that.dynamicTags.push(cartInfo)
          })
        }
        that.checked = cartInfo.checkAll
        this.$emit('updateProductContent', that.dynamicTags)
      })
    },
    // 监听退出成功购物车
    onLogoutSuccess() {
      const that = this
      eventBus.$on('logoutSuccess', cartInfo => {
        that.checked = false
        that.dynamicTags = []
        that.isLogin = false
        that.jbo = []
        this.$emit('updateProductContent', that.dynamicTags)
      })
    },
    // 去购物车结算方法
    cartConfirm() {
      // 查找出选中的购物车项
      let selectedList = this.dynamicTags.filter((item, index) => {
        return item.is_selected
      })
      if (selectedList.length === 0) {
        this.$message.warning('请选择需要的数据！')
      } else if (selectedList.length > 2000) {
        this.$message.warning('最多同时选择2000个产品!')
      } else {
        let user = sessionStorage.getItem('user')
        // 用户已登录跳转到交付方式确认页面
        if (user !== null) {
          // 选中的购物车信息
          let cartInfo = {
            selectedList: selectedList,
            totalAmount: this.totalAmount
          }
          // 选中的购物车信息放到本地存储中
          sessionStorage.setItem('cartInfo', JSON.stringify(cartInfo))
          // 跳转到订单提交页面
          this.$router.push('/order/payDetail')
        } else {
          // 用户未登录跳转到登录页面
          eventBus.$emit('showLoginDialog', true)
        }
      }
    },
    zicheck (val, index, item) {
      var ck = true
      this.dynamicTags.forEach(el => {
        if (el.is_selected) {
          this.isshow = true
        } else {
          ck = false
        }
      })
      this.checked = ck

      // 更新购物车状态
      let message = []
      // 校验用户是否登录
      this.sapost('/dmc/cart/checkLogin', '', r => {
        let result = r.data
        if (result.islogin === 1) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
        if (this.isLogin) {
          let selectedList = {
            'id': item.shopping_cart_item_id,
            'is_selected': val
          }
          message.push(selectedList)
        } else {
          let cartSelectInfo = {
            'pkid': item.pkid,
            'is_selected': val
          }
          message.push(cartSelectInfo)
        }
        this.updateCartSelect(message)
      })
    },
    call () {
      this.jbo = []
      let message = []
      // 校验用户是否登录
      this.sapost('/dmc/cart/checkLogin', '', r => {
        let result = r.data
        if (result.islogin === 1) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
        this.dynamicTags.forEach(el => {
          if (this.checked) {
            el.is_selected = true
            this.isshow = true
            this.jbo.push(el)
          } else {
            el.is_selected = false
            this.isshow = false
            this.jbo = []
          }
          if (this.isLogin) {
            let selectedList = {
              'id': el.shopping_cart_item_id,
              'is_selected': el.is_selected
            }
            message.push(selectedList)
          } else {
            let cartSelectInfo = {
              'pkid': el.pkid,
              'is_selected': el.is_selected
            }
            message.push(cartSelectInfo)
          }
        })
        // 更新购物车状态
        this.updateCartSelect(message)
      })
    },
    // 更新购物车状态
    updateCartSelect(message) {
      // 校验用户是否登录
      this.sapost('/dmc/cart/checkLogin', '', r => {
        let result = r.data
        if (result.islogin === 1) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
        if (this.isLogin) {
          let selectedList = {
            selectedList: JSON.stringify(message)
          }
          this.sapost('/dmc/cart/isSelected', selectedList, r => {
          })
        } else {
          let updateCartData = {
            'op': 'updatecart',
            'message': JSON.stringify(message)
          }
          this.sapost('/dmc/cart/session', updateCartData, r => {
          })
        }
      })
    },
    selectaddall (val, e) {
      console.log('清空')
      // 校验用户是否登录
      this.sapost('/dmc/cart/checkLogin', '', r => {
        let result = r.data
        if (result.islogin === 1) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
        // 已登录
        if (this.isLogin) {
          let productGeometryJson = []
          this.dynamicTags.forEach(cart => {
            let shoppingCartItemId = {
              shopping_cart_item_id: cart.shopping_cart_item_id
            }
            productGeometryJson.push(shoppingCartItemId)
          })
          let user = {
            userId: '',
            userName: '',
            nickName: ''
          }
          user = JSON.parse(sessionStorage.getItem('user'))
          var data = {
            'customerid': user.userId,
            'op': 'del',
            'carttype': this.$route.path === '/remoteSenseData' ? '0' : '1',
            'product_geometry_json': JSON.stringify(productGeometryJson)
          }
          this.sapost('/dmc/cart/cartoperation', data, r => {
          })
        } else {
        // 未登录
          let message = []
          this.dynamicTags.forEach(cart => {
            let pkid = {
              pkid: cart.pkid
            }
            message.push(pkid)
          })
          // 删除购物车
          let deleCartData = {
            'op': 'delcart',
            'message': JSON.stringify(message)
          }
          this.sapost('/dmc/cart/session', deleCartData, r => {
          })
        }
        this.dynamicTags = []
        this.checked = false
        this.jbo = []
        this.$emit('sendclearall', this.dynamicTags)
      })
    },
    selectinfoshow (val, e) {
      var ps = e.currentTarget.parentNode.parentNode.parentNode.childNodes
      console.log(ps)
      for (var i = 0; i < ps.length; i++) {
        console.log(ps[i])
        ps[i].getElementsByTagName('i')[2].style.color = '#ccc'
      }
      e.currentTarget.style.color = '#18bc9c'
      if (val.area_of_interest === '' || val.area_of_interest === undefined) {
        let data = {
          'range': val.range,
          'gid': val.gid
        }
        this.sapost('/dmc/cart/getGeometry', data, r => {
          Map.AddWKT2Source(r.data, true)
        })
      } else {
        Map.AddWKTs2Source(val.area_of_interest, true, 'geometry', !this.$route.path === '/remoteSenseData')
      }
    },
    selectinfoadd (index, e) {
      // if (e.currentTarget.style.color === 'rgb(24, 188, 156)') {
      //   e.currentTarget.style.color = '#ccc'
      // } else {
      //   e.currentTarget.style.color = '#18bc9c'
      // }

      // 校验用户是否登录
      this.sapost('/dmc/cart/checkLogin', '', r => {
        let result = r.data
        if (result.islogin === 1) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
        // 删除购物车
        // 已登录
        if (this.isLogin) {
          let user = {
            userId: '',
            userName: '',
            nickName: ''
          }
          user = JSON.parse(sessionStorage.getItem('user'))
          let productGeometryJson = [
            {
              'shopping_cart_item_id': this.dynamicTags[index].shopping_cart_item_id
            }
          ]
          var data = {
            'customerid': user.userId,
            'op': 'del',
            'carttype': this.$route.path === '/remoteSenseData' ? '0' : '1',
            'product_geometry_json': JSON.stringify(productGeometryJson)
          }
          this.sapost('/dmc/cart/cartoperation', data, r => {
          })
        } else {
        // 未登录
          let pkid = {
            pkid: this.dynamicTags[index].pkid
          }
          let message = []
          message.push(pkid)
          let deleCartData = {
            'op': 'delcart',
            'message': JSON.stringify(message)
          }
          this.sapost('/dmc/cart/session', deleCartData, r => {
          })
        }
        this.dynamicTags.splice(index, 1)
        if (this.dynamicTags.length === 0) {
          this.checked = false
        }
        this.$emit('sendclearall', this.dynamicTags)
      })
    },
    selectinfo (val, e) {
      var hob = {}
      hob.msg = true
      var ps = e.currentTarget.parentNode.parentNode.getElementsByTagName('div')
      if (e.currentTarget.style.color === 'rgb(24, 188, 156)') {
        e.currentTarget.style.color = '#ccc'
        hob.msg = false
      } else {
        ps[0].getElementsByTagName('i')[0].style.color = '#ccc'
        e.currentTarget.style.color = '#18bc9c'
        hob.msg = true
      }
      hob.data = val
      console.log(hob)
      this.$emit('getselectinfovisible', hob)
    },
    sendMsgToParent () {
      this.$emit('getproductcartdialogFormVisible', this.dialogFormVisible)
    },
    closed (e) {
      this.dialogFormVisible = false
      var hob = e.currentTarget.parentNode.parentNode.parentNode.lastChild.lastChild.getElementsByTagName('i')
      for (var i = 0; i < hob.length; i++) {
        hob[i].style.color = '#ccc'
      }
      this.checked = false
      this.isshow = false
    }
  },
  watch: {
    msgFather (curVal) {
      console.log(curVal)
      this.dialogFormVisible = curVal
    },
    dialogFormVisible () {
      this.sendMsgToParent()
    },
    prodata (data) {
      this.dynamicTags = data
    }
  }
}
</script >
<style lang="less">
.cartlistbody {
  display: flex;
  flex-flow: column;
  font-size: 12px;
  text-align: left;
  padding-left: 25px;
  line-height: 1.8;
  color: rgb(24, 188, 156);
}
.cartlisttitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #18bc9c;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #18bc9c;
    border-color: #18bc9c;
  }
}
.zidingy .el-button:focus {
  color: #fff;
  border-color: red;
  font-size: 12px;
  background-color: red;
  border-radius: 0px;
  padding: 10px;
  width: 80%;
}
.zidingy .el-button:hover {
  color: #fff;
  border-color: red;
  font-size: 12px;
  background-color: red;
  border-radius: 0px;
  padding: 10px;
  width: 80%;
}
.zidingy .el-button {
  background-color: red;
  border-color: red;
  font-size: 12px;
  color: #fff;
  border-radius: 0px;
  padding: 10px;
  width: 80%;
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background-color: #fff;
}
::-webkit-scrollbar-thumb {
  background-color: #18bc9c;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #18bc9c;
}
::-webkit-scrollbar-thumb:active {
  background-color: #18bc9c;
}
.gundong {
  overflow-y: auto;
  overflow-x: hidden;
  height: 94%;
}
.listcheckall {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 48px;
  padding-top: 10px;
}
.listcheckall i {
  margin-top: 0px;
  color: #18bc9c;
  cursor: pointer;
}
.listcheckbody {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 12px;
}
.listcheckbody i {
  margin-top: 0px;
  color: #ccc;
  cursor: pointer;
}
.listcheckbody i:hover {
  margin-top: 0px;
  color: #18bc9c;
  cursor: pointer;
}
.is_active {
  margin-top: 5px;
  color: #18bc9c;
  cursor: pointer;
}
.listbody {
  height: 94%;
}
.listhead {
  display: flex;
  background-color: #191b2e;
  height: 20px;
  padding: 10px;
  justify-content: space-between;
  color: #fff;
  font-size: 14px;
}
.divliebiaor {
  background-color: #191b2e;
  width: 300px;
  height: 100%;

  margin-right: 60px;
}
.divliebiaoright {
  width: 300px;
  height: 100%;
  background-color: #fff;
}
.el-checkbox__label {
  display: inline;
  padding-left: 10px;
  line-height: 19px;
  font-size: 14px;
  color: #18bc9c;
}
</style>



// WEBPACK FOOTER //
// src/components/RightMenu/HeadProductCartDialog.vue